<template>
  <div class="page">
    <box fill>
      <el-form label-position="right" label-width="80px">
        <el-row>
          <el-col :lg="5" :xl="5">
            <el-form-item label="申请单号" class="EL-Form-Item">
              <el-input v-model="pagination.samCode" placeholder="请输入"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="物料编号" class="EL-Form-Item">
              <el-input v-model="pagination.matCode" placeholder="请输入"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="物料描述" class="EL-Form-Item">
              <el-input v-model="pagination.matName" placeholder="请输入"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="申请状态" class="EL-Form-Item">
              <el-select v-model="pagination.status">
                <el-option label="默认(待审批、审批完成、拣配中、拣配完成)" value="10,20,40,50"></el-option>
                <el-option label="待审批" value="10"></el-option>
                <el-option label="审批完成" value="20"></el-option>
                <!-- <el-option label="待拣配" value="30"></el-option> -->
                <el-option label="拣配中" value="40"></el-option>
                <el-option label="拣配完成" value="50"></el-option>
                <el-option label="出库完成" value="60"></el-option>
                <el-option label="关闭" value="70"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="4" :xl="4">
            <el-form-item class="btn-edit-delete EL-Form-Item">
              <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                查询
              </el-button>
              <el-button class="btn-t-delete" @click="resetData()">
                重置
              </el-button>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="部门" class="EL-Form-Item">
              <el-select v-model="pagination.section" placeholder="请选择" filterable clearable="clearable">
                <el-option v-for="(item, index) in dictDataList" :key="index" :label="item.deptCode + ' - ' + item.deptName" :value="item.deptCode"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="开始日期" class="EL-Form-Item">
              <el-date-picker v-model="pagination.requireDate[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="结束日期" class="EL-Form-Item">
              <el-date-picker v-model="pagination.requireDate[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-divider></el-divider>
      <plabel text="领用申请">
        <el-button class="btn-t-edit" v-authority="'BACK_MENU4_M9_B1'" @click="insert()">新增</el-button>
        <el-button class="btn-t-edit" v-authority="'BACK_MENU4_M9_B2'" @click="update()">修改</el-button>
        <el-button v-authority="'BACK_MENU4_M9_B3'" class="btn-t-edit" type="primary" @click="prints()">单据打印</el-button>
        <el-button v-authority="'BACK_MENU4_M9_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
      </plabel>
      <!-- 展示 -->
      <h-table
        v-loading="auxiMaterialLoading"
        :headerCellStyle="headerCellStyle"
        style="flex: 1"
        @pageChange="getAuxiMaterialData"
        :data="mainData"
        pagination
        :nowPage.sync="pageMap.pageNum"
        :pageSize.sync="pageMap.pageSize"
        :total.sync="pageMap.total"
        @selectionChange="selectAll"
      >
        <el-table-column type="selection" align="center"> </el-table-column>
        <el-table-column label="申请单号" prop="samCode" align="center"> </el-table-column>
        <el-table-column label="物料编号" prop="matCode" align="center"> </el-table-column>
        <el-table-column label="物料描述" prop="matName" align="center"> </el-table-column>
        <el-table-column label="物料类型" prop="mtType" align="center"> </el-table-column>
        <el-table-column label="需求数量" prop="matQuan" align="center"> </el-table-column>
        <el-table-column label="申请人员" prop="person" align="center"> </el-table-column>
        <el-table-column label="申请部门" prop="section" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.section }} - {{ scope.row.deptName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.status == '10'">待审批</div>
            <div v-if="scope.row.status == '20'">审批完成</div>
            <div v-if="scope.row.status == '30'">待拣配</div>
            <div v-if="scope.row.status == '40'">拣配中</div>
            <div v-if="scope.row.status == '50'">拣配完成</div>
            <div v-if="scope.row.status == '60'">出库完成</div>
            <div v-if="scope.row.status == '70'">关闭</div>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" prop="createTime" palign="center"> </el-table-column>
        <el-table-column label="需求时间" prop="requireDate" align="center"> </el-table-column>
        <el-table-column label="审批部门" prop="examineType" align="center"> </el-table-column>
        <el-table-column label="申请审批人员" prop="examineWaitPerson" align="center"> </el-table-column>
        <el-table-column label="备注" prop="remark" align="center"> </el-table-column>
        <el-table-column label="产品型号" prop="productModel" align="center"> </el-table-column>
        <el-table-column label="工单数量" prop="orderQuantity" align="center"> </el-table-column>
        <el-table-column label="寿命" prop="life" align="center"> </el-table-column>
        <el-table-column label="工序" prop="ddName" align="center"> </el-table-column>
        <el-table-column label="审批状态" prop="checkFlag" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.checkFlag == '10'">通过</div>
            <div v-if="scope.row.checkFlag == '20'">不通过</div>
          </template>
        </el-table-column>
        <el-table-column label="不通过原因" prop="checkMessage" align="center"> </el-table-column>
        <el-table-column label="审批人员编号" prop="examineEmp" align="center"> </el-table-column>
        <el-table-column label="拣货数量" prop="pickQuan" align="center"> </el-table-column>
        <el-table-column label="拣货备注" prop="pickRemark" align="center"> </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-authority="'BACK_MENU4_M9_B5'" class="btn-t-delete" type="danger" @click="closeStatus(scope.row)" :disabled="scope.row.status != '10' ? true : false">关闭</el-button>
          </template>
        </el-table-column>
      </h-table>
    </box>

    <!-- 新增/编辑 -->
    <el-dialog class="fromDialog" :style="$popups.popups(0.8, 0.65)" :title="add_or_edit ? '编辑领用申请单' : '新增领用申请单'" :visible.sync="deliveryInShow" :show-close="false">
      <el-form label-width="110px" :rules="rules" ref="mainObj" :model="mainObj" v-if="add_or_edit == false">
        <el-col :lg="6" :xl="6">
          <el-form-item label="物料类型" prop="mtType" class="EL-Form-Item">
            <el-select v-model="mainObj.mtType" placeholder="请选择" filterable clearable="clearable" @change="changeItemClass()">
              <el-option v-for="(item, index) in mtTypeList" :key="index" :label="item.ddCode + ' - ' + item.ddName" :value="item.ddCode"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :xl="6">
          <el-form-item label="物料编号" prop="matCode" class="EL-Form-Item">
            <el-select v-model="mainObj.matCodeAndName" placeholder="请选择" filterable @change="changeMatCode(mainObj.matCodeAndName)" remote :remote-method="remoteMethod" :loading="loading">
              <el-option v-for="(item, index) in materialList" :key="index" :label="item.matCode + '-' + item.matName" :value="item.matCode + '-' + item.matName"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :xl="6">
          <el-form-item label="可用库存" prop="inQuan" class="EL-Form-Item">
            <el-input v-model="inQuan" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :xl="6">
          <el-form-item label="需求数量" prop="matQuan" class="EL-Form-Item">
            <el-input-number v-model="mainObj.matQuan" :min="1" @change="matQuanJudge(mainObj.matQuan)"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :xl="6">
          <el-form-item label="申请部门" prop="section" class="EL-Form-Item">
            <el-select v-model="mainObj.section" placeholder="请选择" filterable clearable="clearable" @change="getDictUser(mainObj.section, true)">
              <el-option v-for="(item, index) in dictDataList" :key="index" :label="item.deptCode + ' - ' + item.deptName" :value="item.deptCode"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :xl="6">
          <el-form-item label="审批人员" prop="examineWaitEmp" class="EL-Form-Item">
            <el-select v-model="mainObj.examineWaitEmp" multiple collapse-tags placeholder="请选择" clearable="clearable" @change="setExamineWait">
              <el-option v-for="(item, index) in dictUserList" :key="index" :label="item.empNumber + ' - ' + item.userName" :value="item.empNumber"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :xl="6">
          <el-form-item label="需求时间" prop="requireDate" class="EL-Form-Item">
            <el-date-picker v-model="mainObj.requireDate" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :xl="6">
          <el-form-item label="备注" prop="remark" class="EL-Form-Item">
            <el-input v-model="mainObj.remark"></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :xl="6">
          <el-form-item label="产品型号" prop="productModel" class="EL-Form-Item">
            <!-- <el-input v-model="mainObj.productModel"></el-input> -->
            <el-select v-model="mainObj.productModel" placeholder="请选择" filterable remote :remote-method="productModelRemoteMethod" :loading="productModelLoading">
              <el-option v-for="(item, index) in productModelList" :key="index" :label="item.mtCode" :value="item.mtCode"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :xl="6">
          <el-form-item label="工单数量" prop="orderQuantity" class="EL-Form-Item">
            <el-input v-model="mainObj.orderQuantity" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :xl="6">
          <el-form-item label="寿命" prop="life" class="EL-Form-Item">
            <el-input v-model="mainObj.life"></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :xl="6">
          <el-form-item label="工序" prop="procedureCode" class="EL-Form-Item">
            <el-select v-model="mainObj.procedureCode" placeholder="请选择" clearable="clearable">
              <el-option v-for="(item, index) in deptCodeTypeList" :key="index" :label="item.ddName" :value="item.ddCode"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
      <div style="padding:10px 0; float:right" v-if="add_or_edit == false">
        <el-button :loading="MaterialDatas" class="btn-t-edit" @click="affirmAdd()" type="primary">确认</el-button>
        <el-button @click="cancelAdd()" type="danger" class="btn-t-delete">清除</el-button>
      </div>
      <el-form :inline="true" label-position="top" label-width="110px" :rules="rules" ref="mainObj" :model="mainObj" v-if="add_or_edit == true">
        <el-col :lg="6" :xl="6">
          <el-form-item label="物料类型" prop="mtType" class="EL-Form-Item">
            <el-select v-model="mainObj.mtType" placeholder="请选择" filterable clearable="clearable">
              <el-option v-for="(item, index) in mtTypeList" :key="index" :label="item.ddCode + ' - ' + item.ddName" :value="item.ddCode"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :xl="6">
          <el-form-item label="物料编号" prop="matCode" class="EL-Form-Item">
            <el-select v-model="mainObj.matCode" placeholder="请选择" @change="changeMatCode(mainObj.matCode)" filterable remote :remote-method="remoteMethod" :loading="loading">
              <el-option v-for="(item, index) in materialList" :key="index" :label="item.matCode" :value="item.matCode"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :xl="6">
          <el-form-item label="物料描述" prop="matName" class="EL-Form-Item">
            <el-input v-model="mainObj.matName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :xl="6">
          <el-form-item label="需求数量" prop="matQuan" class="EL-Form-Item">
            <el-input-number v-model="mainObj.matQuan" :min="1"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :xl="6">
          <el-form-item label="申请部门" prop="section" class="EL-Form-Item">
            <el-select v-model="mainObj.section" placeholder="请选择" filterable clearable="clearable" @change="getDictUser(mainObj.section, true)">
              <el-option v-for="(item, index) in dictDataList" :key="index" :label="item.deptCode + ' - ' + item.deptName" :value="item.deptCode"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :xl="6">
          <el-form-item label="审批人员" prop="examineWaitEmp" class="EL-Form-Item">
            <el-select v-model="mainObj.examineWaitEmp" multiple collapse-tags placeholder="请选择" clearable="clearable" @change="setExamineWait">
              <el-option v-for="(item, index) in dictUserList" :key="index" :label="item.empNumber + ' - ' + item.userName" :value="item.empNumber"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :xl="6">
          <el-form-item label="需求时间" prop="requireDate" class="EL-Form-Item">
            <el-date-picker v-model="mainObj.requireDate" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form>
      <h-table :style="$popups.harvestRecordStyle(0.3)" :headerCellStyle="headerCellStyle" :data="addAuxiMaterialData" v-if="add_or_edit == false">
        <el-table-column label="物料编号" prop="matCode" align="center"> </el-table-column>
        <el-table-column label="物料描述" prop="matName" align="center"> </el-table-column>
        <el-table-column label="物料类型" prop="mtType" align="center"> </el-table-column>
        <el-table-column label="需求数量" prop="matQuan" align="center"> </el-table-column>
        <el-table-column label="申请人员" prop="person" align="center"> </el-table-column>
        <el-table-column label="部门" prop="section" align="center"> </el-table-column>
        <el-table-column label="申请审批人员" prop="examineWaitPerson" align="center"> </el-table-column>
        <el-table-column label="需求时间" prop="requireDate" align="center"> </el-table-column>
        <el-table-column label="备注" prop="remark" align="center"> </el-table-column>
        <el-table-column label="产品型号" prop="productModel" align="center"> </el-table-column>
        <el-table-column label="工单数量" prop="orderQuantity" align="center"> </el-table-column>
        <el-table-column label="寿命" prop="life" align="life"> </el-table-column>
        <el-table-column label="工序" prop="procedureCode" align="center"> </el-table-column>
        <el-table-column label=" 操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="dataListDelAdd(scope.row, scope.$index)" class="btn-t-delete">删除</el-button>
          </template>
        </el-table-column>
      </h-table>
      <div slot="footer" class="dialog-footer footer-bottom">
        <el-button @click="cancel()" type="info" class="btn-t-info">取 消</el-button>
        <el-button :loading="MaterialDatas" class="btn-t-edit" v-if="add_or_edit == false" @click="insertAuxiMaterialData()" type="primary">申 请</el-button>
        <el-button :loading="MaterialDatas" class="btn-t-edit" v-if="add_or_edit == true" @click="updateAuxiMaterialData()" type="primary">编 辑</el-button>
      </div>
    </el-dialog>

    <!-- 拣货详情 -->
    <el-dialog title="申请详情（提交拣货）" :visible.sync="returnDialogShow" class="fromDialog" :style="$popups.popups(0.8, 0.9)">
      <h-table :style="$popups.harvestRecordStyle(0.75)" :headerCellStyle="headerCellStyle" :data="returnData">
        <el-table-column label="申请单号" prop="samCode" align="center"> </el-table-column>
        <el-table-column label="物料编号" prop="matCode" align="center"> </el-table-column>
        <el-table-column label="物料描述" prop="matName" align="center"> </el-table-column>
        <el-table-column label="需求数量" prop="matQuan" align="center"> </el-table-column>
        <el-table-column label="申请人员" prop="person" align="center"> </el-table-column>
        <el-table-column label="部门" prop="section" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.section }} - {{ scope.row.deptName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.status == '10'">待审批</div>
            <div v-if="scope.row.status == '20'">审批完成</div>
            <div v-if="scope.row.status == '30'">待拣配</div>
            <div v-if="scope.row.status == '40'">拣配中</div>
            <div v-if="scope.row.status == '50'">拣配完成</div>
            <div v-if="scope.row.status == '60'">出库完成</div>
            <div v-if="scope.row.status == '70'">关闭</div>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" prop="createTime" palign="center"> </el-table-column>
        <el-table-column label="需求时间" prop="requireDate" align="center"> </el-table-column>
        <el-table-column label="审批状态" prop="checkFlag" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.checkFlag == '10'">通过</div>
            <div v-if="scope.row.checkFlag == '20'">不通过</div>
          </template>
        </el-table-column>
        <el-table-column label="审批人员编号" prop="examineEmp" align="center"> </el-table-column>
        <el-table-column label=" 操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="dataListDel(scope.row.samId)" class="btn-t-delete">删除</el-button>
          </template>
        </el-table-column>
      </h-table>
      <div slot="footer" class="dialog-footer footer-bottom">
        <el-button class="btn-t-info" @click="returnClose" type="info">取 消</el-button>
        <el-button class="btn-t-edit" @click="orderPicking" type="danger">拣 货</el-button>
      </div>
    </el-dialog>

    <!-- 直接出库 -->
    <el-dialog title="申请详情（直接出库）" class="fromDialog" :style="$popups.popups(0.8, 0.9)" :visible.sync="outInventoryShow">
      <h-table :headerCellStyle="headerCellStyle" :style="$popups.harvestRecordStyle(0.75)" :data="outInventoryList">
        <el-table-column label="申请单号" prop="samCode" align="center"> </el-table-column>
        <el-table-column label="物料编号" prop="matCode" align="center"> </el-table-column>
        <el-table-column label="物料描述" prop="matName" align="center"> </el-table-column>
        <el-table-column label="需求数量" prop="matQuan" align="center"> </el-table-column>
        <el-table-column label="申请人员" prop="person" align="center"> </el-table-column>
        <el-table-column label="部门" prop="section" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.section }} - {{ scope.row.deptName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.status == '10'">待审批</div>
            <div v-if="scope.row.status == '20'">审批完成</div>
            <div v-if="scope.row.status == '30'">待拣配</div>
            <div v-if="scope.row.status == '40'">拣配中</div>
            <div v-if="scope.row.status == '50'">拣配完成</div>
            <div v-if="scope.row.status == '60'">出库完成</div>
            <div v-if="scope.row.status == '70'">关闭</div>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" prop="createTime" palign="center"> </el-table-column>
        <el-table-column label="需求时间" prop="requireDate" align="center"> </el-table-column>
        <el-table-column label="审批状态" prop="checkFlag" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.checkFlag == '10'">通过</div>
            <div v-if="scope.row.checkFlag == '20'">不通过</div>
          </template>
        </el-table-column>
        <el-table-column label="审批人员编号" prop="examineEmp" align="center"> </el-table-column>
        <el-table-column label=" 操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="dataListDel(scope.row.samId)" class="btn-t-delete">删除</el-button>
          </template>
        </el-table-column>
      </h-table>
      <div slot="footer" class="dialog-footer footer-bottom">
        <el-button class="btn-t-info" @click="(outInventoryList = []), (outInventoryShow = false)" type="info">取 消</el-button>
        <el-button class="btn-t-edit" @click="outInventoryAffirm" type="danger">确 认</el-button>
      </div>
    </el-dialog>

    <!-- 打印 -->
    <el-dialog title="打印" :visible.sync="printShow" width="1200px" :close-on-click-modal="false">
      <div style="margin-top:20px;margin-left:900px;margin-bottom:20px">
        <el-button class="btn-t-info" type="info" @click="(printShow = false), (printList = [])">取消</el-button>
        <el-button class="btn-t-edit" @click="(print = true), (printShow = false)">打印</el-button>
      </div>
      <v-print :doPrint.sync="print">
        <div id="demo" class="demo">
          <div>
            <div class="table">
              <table width="100%" border="1" cellpadding="0" cellspacing="0">
                <tr>
                  <th>SKF</th>
                  <th colspan="3" rowspan="3">Special Withdraw Requisition <br /><span>特殊领用申请单</span></th>
                  <th rowspan="2" style="font-size: 12px">ForM No.</th>
                  <th colspan="2" style="font-size: 12px">Quaity Document Ref</th>
                </tr>
                <tr>
                  <th rowspan="2" style="font-size: 12px">SKF DaLian</th>
                  <th style="font-size: 12px">Doc.Name</th>
                  <th style="font-size: 12px">Section</th>
                </tr>
                <tr>
                  <th style="font-size: 12px">Revision No.</th>
                  <th style="font-size: 12px">Date（YY.MM）</th>
                  <th style="font-size: 12px">Pages</th>
                </tr>
              </table>
            </div>
          </div>
          <div>
            <div class="table">
              <table width="100%" border="1" cellpadding="0" cellspacing="0">
                <tr>
                  <td>Req.No<br />申请单号</td>
                  <td colspan="2"></td>
                  <td>Cost Ctr<br />成本中心</td>
                  <td></td>
                  <td>Date<br />日期</td>
                  <td>{{ timeDate }}</td>
                </tr>
                <tr>
                  <td colspan="2">Stock Code<br />库存编号</td>
                  <td>Quantity<br />数量</td>
                  <td colspan="3">Intiate Reason<br />申请原因</td>
                  <td>Remarks<br />备注</td>
                </tr>
                <tr v-for="(item, index) in printList" :key="index">
                  <td colspan="2">{{ item.matCode }}</td>
                  <td>{{ item.matQuan }}</td>
                  <td colspan="3"></td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="2"></td>
                  <td></td>
                  <td colspan="3"></td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="2"></td>
                  <td></td>
                  <td colspan="3"></td>
                  <td></td>
                </tr>
                <tr>
                  <td rowspan="2">Request & Approval<br />申请/批准</td>
                  <td>Initiator<br />申请人</td>
                  <td>Depar. Mgr<br />部门经理</td>
                  <td>Planner<br />计划员</td>
                  <td>Controller<br />成本控制</td>
                  <td>WH Worker<br />库管员</td>
                  <td>WH Supervisor<br />通道主管</td>
                </tr>
                <tr>
                  <td>{{ person }}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </v-print>
      <div class="print" style="margin-top: 50px;margin-bottom:50px;"></div>
    </el-dialog>
  </div>
</template>

<script>
import vPrint from "syl-vue-printer";
import moment from "moment";
export default {
  name: "GetApply",
  components: {
    vPrint,
  },
  data() {
    return {
      auxiMaterialLoading: true,
      addAuxiMaterialData: [],
      //打印
      print: false,
      printShow: false,
      printList: [],
      timeDate: "",

      headerCellStyle: () => {
        return "background-color: #1f5cec";
      },
      form: {},
      //弹出框
      deliveryInShow: false,
      // 新增or编辑
      add_or_edit: false,
      //新增
      mainObjForm: [],
      mainObj: {
        index: "",
        samId: "",
        matCode: "",
        matName: "",
        section: "",
        person: localStorage.getItem("user") || "",
        orderCode: "",
        fcCode: localStorage.getItem("fcCode") || "",
        status: "10",
        requireDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        matQuan: 0,
        remark: "",
        mtType: "",
        directInventory: "false",
        personNumber: localStorage.getItem("empNumber") || null,
        section: "",
        examineWaitEmp: "",
        examineWaitPerson: "",
        matCodeAndName: "",
      },
      inQuan: 0,
      matCodeList: [],
      mtTypes: "",
      //主数据
      mainData: [],
      pagination: {
        samCode: "",
        matCode: "",
        matName: "",
        section: "",
        person: localStorage.getItem("user"),
        orderCode: "",
        status: "10,20,40,50",
        requireDate: [],
        fcCode: localStorage.getItem("fcCode") || "",
      },
      pageMap: {
        pageNum: 1,
        pageSize: 50,
        total: 0,
      },
      //新增框校验
      rules: {
        matCode: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        matQuan: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        section: [
          {
            required: true,
            message: "请选择",
            trigger: "blur",
          },
        ],
        examineWaitEmp: [{
            required: true,
            message: "请选择",
            trigger: "blur",
        }, ],
        requireDate: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        productModel: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        orderQuantity: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        life: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        procedureCode: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
      },
      deptCodeTypeList: [],
      fcCode: localStorage.getItem("fcCode") || "",
      person: localStorage.getItem("user") || "",
      personNumber: localStorage.getItem("empNumber") || null,
      whCode: localStorage.getItem("whCode") || "",
      //全选
      checkList: [],
      checkListExamine: [],

      //拣货
      returnDialogShow: false,
      returnData: [],

      downloadLoadingExamine: false,

      dictDataList: [],
      dictUserList: [],
      mtTypeList: [],
      selectExamineAuxiList: [],

      //直接出库
      outInventoryShow: false,
      outInventoryList: [],

      //审批
      checkMessage: "",
      checkFlag: "",
      section: "",
      examineData: [],
      quanbu: "1",

      panduan: true,

      //物料集合
      materialList: [],
      loading: false, //加载中
      //产品型号集合
      productModelList: [],
      productModelLoading: false, //加载中

      downloadLoading: false, //下载中
      examineQuerens: false,
      MaterialDatas: false,

      logContent: "", //操作日志-内容
      logRemarks: "", //操作日志-备注
      // 输入框延时加载
      isSetTimeout: null,
    };
  },
  watch: {
    pagination: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.pageMap.pageNum = 1;
          this.getAuxiMaterialData(newVal);
        }, 1000);
      },
      deep: true,
    },
  },
  computed: {
    pickerOptions() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.pagination.requireDate[0]) {
            return time.getTime() < new Date(_this.pagination.requireDate[0]);
          }
        },
      };
    },
    pickerOptions0() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.pagination.requireDate[1]) {
            return time.getTime() > new Date(_this.pagination.requireDate[1]);
          }
        },
      };
    },
  },
  methods: {
    //需求数量判断
    matQuanJudge(matQuan) {
      if (matQuan > this.inQuan) {
        this.$message({
          message: "库存数量不够！",
          type: "warning",
        });
        this.mainObj.matQuan = 0;
        return;
      }
    },

    affirmAdd() {
      if (this.submitForm("mainObj")) {
        const applyData = {...this.mainObj}
        applyData.examineWaitEmp = "," + applyData.examineWaitEmp.join(",") + ",";
        this.addAuxiMaterialData.push(applyData);
        // this.cancelAdd();

        console.log(this.addAuxiMaterialData);
      }
    },
    selectExamineAuxi(val) {
      this.selectExamineAuxiList = val;
    },
    // 节流搜索
    saveSearch() {
      if (window.lazy) window.clearTimeout(window.lazy);
      window.lazy = window.setTimeout(() => {
        this.getAuxiMaterialData();
      }, 1000);
    },
    //获取数据
    getAuxiMaterialData() {
      this.$http
        .request({
          url: "/api/auxiMaterial/getAuxiMaterialList",
          method: "GET",
          params: {
            pageNum: this.pageMap.pageNum || null,
            pageSize: this.pageMap.pageSize || null,
            samCode: this.pagination.samCode || null,
            matCode: this.pagination.matCode || null,
            matName: this.pagination.matName || null,
            section: this.pagination.section || null,
            person: this.pagination.person || null,
            orderCode: this.pagination.orderCode || null,
            status: this.pagination.status || null,
            // requireDate: this.pagination.requireDate || null,
            beginTime: this.pagination.requireDate[0] || null,
            endTime: this.pagination.requireDate[1] || null,
            fcCode: this.pagination.fcCode || null,
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.mainData = resp.data.list || [];
            this.pageMap.total = resp.data.total;
          }
          this.auxiMaterialLoading = false;
        })
        .catch((error) => {
          this.$message({
            message: "操作失败",
            type: "warning",
          });
        });
    },
    changeMatCode(matCode) {
      if (matCode != null) {
        let matCodeInfo = this.materialList.find((i) => i.matCode + "-" + i.matName == matCode);
        this.mainObj.matName = matCodeInfo.matName;
        //this.mainObj.mtType = matCodeInfo.itemType;
        this.inQuan = matCodeInfo.matQuan;
        this.mainObj.matCode = matCodeInfo.matCode;
      }
    },
    //新增弹出框
    insert() {
      this.getmtTypeList();
      this.getDepartmentData();
      this.getMaterialAll();
      this.deliveryInShow = true;
    },
    //新增
    insertAuxiMaterialData() {
      if (this.addAuxiMaterialData.length == 0) {
        this.$message({
          message: "暂无新增申请单！",
          type: "warning",
        });
        return;
      }
      this.MaterialDatas = true;
      this.$http
        .request({
          url: "/api/auxiMaterial/insertAuxiMaterialData",
          method: "POST",
          showLoading: true,
          data: this.addAuxiMaterialData,
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getAuxiMaterialData();
            this.cancel();
            this.logRemarks = "auxiMaterial：领用申请新增操作成功";
          } else {
            this.$message({
              message: resp.message,
              type: "warning",
            });
            this.logRemarks = "auxiMaterial：领用申请新增操作失败";
          }
          this.MaterialDatas = false;
          this.logContent = JSON.stringify(this.mainObj);
          this.systemLog();
        })
        .catch((error) => {
          this.$message({
            message: "操作失败",
            type: "warning",
          });
        });
    },
    //编辑
    updateAuxiMaterialData() {
      this.MaterialDatas = true;
      if (this.submitForm("mainObj")) {
        this.mainObj.examineWaitEmp = "," + this.mainObj.examineWaitEmp.join(",") + ",";
        this.$http
          .request({
            url: "/api/auxiMaterial/updateAuxiMaterialData",
            method: "POST",
            showLoading: true,
            data: this.mainObj,
            params: {
              person: localStorage.getItem("user") || "",
              personNumber: localStorage.getItem("empNumber") || "",
            },
          })
          .then((resp) => {
            if (resp.status == 100) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.logRemarks = "auxiMaterial：领用申请编辑操作成功";
            } else {
              this.$message({
                message: "操作失败",
                type: "warning",
              });
              this.logRemarks = "auxiMaterial：领用申请编辑操作失败";
            }
            this.MaterialDatas = false;
            this.logContent = "samCode：" + this.mainObj.samCode;
            this.systemLog();
            this.cancel();
            this.getAuxiMaterialData();
          })
          .catch((error) => {
            this.MaterialDatas = false;
            this.$message({
              message: "操作失败",
              type: "warning",
            });
          });
      } else {
        this.MaterialDatas = false;
      }
    },
    //拣货
    orderPicking() {
      this.$http
        .request({
          url: "/api/auxiMaterial/orderPicking",
          method: "POST",
          showLoading: true,
          data: this.returnData,
          params: {
            fcCode: this.fcCode || null,
            person: this.person || null,

            personNumber: this.personNumber || null,
            whCode: this.whCode || null,
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.logRemarks = "auxiMaterial：领用申请提交拣货单操作成功";
          } else {
            this.$message({
              message: "操作失败",
              type: "warning",
            });
            this.logRemarks = "auxiMaterial：领用申请提交拣货单操作失败";
          }
          this.logContent = this.returnData;
          this.systemLog();
          this.returnClose();
          this.getAuxiMaterialData();
        })
        .catch((error) => {
          this.$message({
            message: "操作失败",
            type: "warning",
          });
        });
    },
    //编辑弹框
    update() {
      if (this.checkList.length == 0) {
        this.$message({
          message: "请勾选申请单！",
          type: "warning",
        });
        return;
      } else if (this.checkList.length > 1) {
        this.$message({
          message: "只能勾选一个申请单！",
          type: "warning",
        });
        return;
      }
      this.checkList.forEach((item) => {
        if (item.status != "10") {
          this.$message({
            message: "创建状态申请单才可以进行修改！",
            type: "warning",
          });
          return;
        }
        if (item.mtType != null) {
          this.mtTypes = "类型A";
        }
        this.mainObj = {
          samId: item.samId,
          samCode: item.samCode,
          matCode: item.matCode,
          matName: item.matName,
          section: item.section,
          examineWaitEmp: item.examineWaitEmp.split(","),
          examineWaitPerson: item.examineWaitPerson,
          person: item.person,
          orderCode: item.orderCode,
          fcCode: item.fcCode,
          status: item.status,
          requireDate: item.requireDate,
          matQuan: item.matQuan,
          remark: item.remark,
          mtType: item.mtType,
          directInventory: item.directInventory == false ? "false" : "true",
          matCodeAndName: "",
        };
        this.add_or_edit = true;
        this.getMaterialAll(this.mainObj.mtType);
        this.getDepartmentData();
        this.getmtTypeList();
        this.getDictUser(this.mainObj.section, false);
        this.deliveryInShow = true;
      });
    },

    //打印
    prints() {
      if (this.checkList.length == 0) {
        this.$message({
          message: "请选择打印单！",
          type: "warning",
        });
        return;
      }
      this.printList = this.checkList;
      this.printShow = true;
      this.getTime();
    },
    //获取当前时间 格式YYYY-MM-DD
    getTime() {
      var date = new Date();
      var seperator1 = "/";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      this.timeDate = year + seperator1 + month + seperator1 + strDate;
    },

    //直接出库
    outInventory() {
      if (this.checkList == 0) {
        this.$message({
          message: "请选择申请记录！",
          type: "warning",
        });
        return;
      }
      let num = 0;
      let direct = 0;
      let out = 0;
      this.checkList.forEach((item) => {
        if (item.status != "20" || item.checkFlag != "10") {
          num += 1;
        }
        if (item.directInventory != true) {
          direct += 1;
        }
        if (item.status == "30" || item.status == "40" || item.status == "50" || item.status == "60" || item.status == "60") {
          out += 1;
        }
      });
      if (out != 0) {
        this.$message({
          message: "不能重复操作！",
          type: "warning",
        });
        return;
      }
      if (num != 0) {
        this.$message({
          message: "审批完成通过的申请单才可以进行直接出库操作！",
          type: "warning",
        });
        return;
      }
      if (direct != 0) {
        this.$message({
          message: "申请单为不可直接出库单！",
          type: "warning",
        });
        return;
      }
      this.outInventoryList = this.checkList;
      this.outInventoryShow = true;
    },
    //确认直接出库
    outInventoryAffirm() {
      this.$confirm("确认申请单直接出库, 是否继续?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .request({
              url: "/api/auxiMaterial/outInventoryAffirm",
              method: "POST",
              showLoading: true,
              data: this.outInventoryList,
              params: {
                person: localStorage.getItem("user"),
                personNumber: localStorage.getItem("empNumber"),
              },
            })
            .then((resp) => {
              if (resp.status == 100) {
                this.$notify({
                  title: "成功",
                  message: "操作成功！",
                  type: "success",
                });
                this.outInventoryList = [];
                this.outInventoryShow = false;
                this.getAuxiMaterialData();
                this.logRemarks = "auxiMaterial：确认申请单直接出库成功";
              } else {
                this.$notify.error({
                  title: "失败",
                  message: resp.message,
                });
                this.logRemarks = "auxiMaterial：确认申请单直接出库失败";
              }
              this.logContent = JSON.stringify(this.outInventoryList);
              this.systemLog();
            })
            .catch((error) => {
              this.$notify.error({
                title: "失败",
                message: "调用失败",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    /**
     * 获取所有的工序类型
     */
    getTypeList() {
      this.$http
        .request({
          url: "/api/dict/getDictTypeByLatypeAll",
          method: "GET",
          params: {
            dtCode: "GXTYPE",
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.deptCodeTypeList = resp.data.list;
          }
        })
        .catch((error) => {
          this.$message({
            message: "操作失败",
            type: "error",
          });
        });
    },
    //删除
    dataListDelAdd(row,index) {
      // var index = this.addAuxiMaterialData.findIndex((item) => {
      //   if (item.index == row.index) {
      //     return true;
      //   }
      // });
      this.addAuxiMaterialData.splice(index, 1);
    },
    //删除
    dataListDel(samId) {
      var index = this.examineData.findIndex((item) => {
        if (item.samId == samId) {
          return true;
        }
      });
      this.examineData.splice(index, 1);
    },
    //关闭
    closeStatus(row) {
      this.$confirm("此操作将关闭申请, 是否继续?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          row.status = "70";
          this.$http
            .request({
              url: "/api/auxiMaterial/updateAuxiMaterialData",
              method: "POST",
              showLoading: true,
              data: row,
            })
            .then((resp) => {
              if (resp.status == 100) {
                this.$notify({
                  title: "成功",
                  message: "关闭成功！",
                  type: "success",
                });
                this.logRemarks = "auxiMaterial：关闭失败";
              } else {
                this.$notify.error({
                  title: "失败",
                  message: "关闭失败",
                });
                this.logRemarks = "auxiMaterial：关闭失败";
              }
              this.logContent = "samCode：" + row.samCode;
              this.systemLog();
              this.getAuxiMaterialData();
            })
            .catch((error) => {
              this.$notify.error({
                title: "失败",
                message: "调用失败",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //获取部门
    getDepartmentData() {
      this.$http
        .request({
          url: "/api/tepartment/getDepartmentData",
          method: "GET",
          showLoading: true,
          params: {
            fcCode: localStorage.getItem("fcCode") || "",
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.dictDataList = resp.data.list || [];
          }
        })
        .catch((error) => {});
    },

    //获取部门审批人员
    getDictUser(deptCode, isEntry) {
      if (isEntry) {
        this.mainObj.examineWaitEmp = "";
        this.mainObj.examineWaitPerson = "";
      }
      this.$http
        .request({
          url: "/api/tepartment/getDeptUser",
          method: "GET",
          params: {
            deptCode: deptCode,
            fcCode: localStorage.getItem("fcCode"),
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.dictUserList = resp.data || [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //获取类型
    getmtTypeList() {
      this.$http
        .request({
          url: "/api/dictData/getDictData",
          method: "GET",
          showLoading: true,
          params: {
            ddCode: "MDTYPE",
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.mtTypeList = resp.data.list || [];
          }
        })
        .catch((error) => {});
    },

    //类别改变
    changeItemClass() {
      this.materialList = [];
      this.mainObj.matCodeAndName = "";
      this.getMaterialAll();
    },

    //获取物料库存数据
    getMaterialAll(query) {
      this.materialList = [];
      this.$http
        .request({
          url: "/api/inventory/getInventoryMaterial",
          method: "GET",
          params: {
            matCode: this.mainObj.matCodeAndName,
            fcCode: localStorage.getItem("fcCode") || "",
            mtType: this.mainObj.mtType,
            //mtName: this.mainObj.matName,
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.materialList = resp.data.list || [];
            if (query != undefined && resp.data.list.length == 1) {
              this.mainObj.matName = this.materialList[0].matName;
              //this.mainObj.mtType = this.materialList[0].itemType;
              this.inQuan = this.materialList[0].matQuan;
              this.mainObj.matCode = this.materialList[0].matCode;
            }
          }
        })
        .catch((error) => {
          this.loading++;
        });
    },
    /**
     * 远程搜索物料描述
     */
    remoteMethodMatName(query) {
      if (query !== "") {
        this.loading = true;
        this.mainObj.matName = query;
        this.getMaterialAll(query);
        setTimeout(() => {
          this.loading = false;
          if (this.materialList != undefined) {
            this.materialList = this.materialList.filter((item) => {
              return item.matName.toLowerCase().indexOf(query.toLowerCase()) > -1;
            });
          }
        }, 200);
      } else {
        this.materialList = [];
      }
    },

    /**
     * 远程搜索物料编号
     */
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        this.mainObj.matCodeAndName = query;
        this.getMaterialAll(query);
        setTimeout(() => {
          this.loading = false;
          if (this.materialList != undefined) {
            this.materialList = this.materialList.filter((item) => {
              return (item.matCode + "-" + item.matName).toLowerCase().indexOf(query.toLowerCase()) > -1;
            });
          }
        }, 200);
      } else {
        this.materialList = [];
      }
    },
    /**
     * 远程搜索产品型号
     */
    productModelRemoteMethod(query) {
      if (query !== "") {
        this.productModelLoading = true;
        this.$http
          .request({
            url: "/api/material/getMaterialAll",
            method: "GET",
            params: {
              pageNum: 1,
              pageSize: 999999,
              mtCode: query,
            },
          })
          .then((resp) => {
            this.productModelLoading = false;
            if (resp.status == 100) {
              this.productModelList = resp.data.list || [];
            }
          })
          .catch((error) => {
            this.productModelLoading = false;
            this.loading++;
          });
      } else {
        this.productModelList = [];
      }
    },

    //全选
    selectAll(val) {
      this.checkList = val;
    },

    //全选
    selectAllExamine(val) {
      this.checkListExamine = val;
    },

    //拣货回显
    returnView() {
      if (this.checkList.length == 0) {
        this.$message({
          message: "请勾选申请单！",
          type: "warning",
        });
        return;
      }
      let num = 0;
      let direct = 0;
      let pink = 0;
      this.checkList.forEach((item) => {
        if (item.status != "20" || item.checkFlag != "10") {
          num += 1;
        }
        if (item.directInventory != false) {
          direct += 1;
        }
        if (item.status == "30" || item.status == "40" || item.status == "50" || item.status == "60" || item.status == "60") {
          pink += 1;
        }
      });

      if (pink != 0) {
        this.$message({
          message: "不能重复操作！",
          type: "warning",
        });
        return;
      }

      if (num != 0) {
        this.$message({
          message: "请审批后通过后再进行拣货！",
          type: "warning",
        });
        return;
      }

      if (direct != 0) {
        this.$message({
          message: "直接出库单不需要拣货！",
          type: "warning",
        });
        return;
      }
      this.returnData = this.checkList;
      this.returnDialogShow = true;
    },
    // 关闭弹出框
    returnClose() {
      this.returnDialogShow = false;
      // this.checkList = [];
      this.returnData = [];
    },
    //重置
    resetData() {
      this.pagination = {
        samCode: "",
        matCode: "",
        matName: "",
        section: "",
        person: localStorage.getItem("user"),
        orderCode: "",
        status: "10,20,40,50",
        requireDate: [],
        fcCode: localStorage.getItem("fcCode") || "",
      };
      // this.getAuxiMaterialData();
    },
    cancelAdd() {
      this.inQuan = "";
      this.mtTypes = "";
      this.mainObj = {
        samId: "",
        matCode: "",
        matName: "",
        section: "",
        examineWaitEmp: "",
        examineWaitPerson: "",
        person: localStorage.getItem("user") || "",
        orderCode: "",
        fcCode: localStorage.getItem("fcCode") || "",
        status: "10",
        requireDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        matQuan: 0,
        remark: "",
        mtType: "",
        directInventory: "false",
        personNumber: localStorage.getItem("empNumber") || null,
        matCodeAndName: "",
      };
      this.dictUserList = [];
    },
    //取消
    cancel() {
      this.addAuxiMaterialData = [];
      this.deliveryInShow = false;
      this.add_or_edit = false;
      this.mtTypes = "";
      this.mainObj = {
        samId: "",
        matCode: "",
        matName: "",
        section: "",
        examineWaitEmp: "",
        examineWaitPerson: "",
        person: localStorage.getItem("user") || "",
        orderCode: "",
        fcCode: localStorage.getItem("fcCode") || "",
        status: "10",
        requireDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        matQuan: 0,
        remark: "",
        mtType: "",
        directInventory: "false",
        personNumber: localStorage.getItem("empNumber") || null,
        matCodeAndName: "",
      };
      this.dictDataList = [];
      this.dictUserList = [];
    },

    //表单验证
    submitForm(formName) {
      let r = Boolean;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          r = true;
        } else {
          r = false;
        }
      });
      return r;
    },

    //表格导出
    downLoadFile() {
      this.downloadLoading = true;
      var paramsObj = {
        samCode: this.pagination.samCode || null,
        matCode: this.pagination.matCode || null,
        matName: this.pagination.matName || null,
        section: this.pagination.section || null,
        person: this.pagination.person || null,
        orderCode: this.pagination.orderCode || null,
        status: this.pagination.status || null,
        // requireDate: this.pagination.requireDate || null,
        beginTime: this.pagination.requireDate[0] || null,
        endTime: this.pagination.requireDate[1] || null,
        fcCode: this.pagination.fcCode || null,
        pageNum: 1,
        pageSize: 999999,
      };

      this.$http
        .request({
          url: "/api/auxiMaterial/getAuxiMaterialList",
          method: "GET",
          showLoading: true,
          params: paramsObj,
        })
        .then((resp) => {
          resp.status == 100
            ? this.downLoad(resp.data.list || [])
            : this.$notify.error({
                message: "查询失败",
              });
        });
    },
    downLoad(list) {
      import("@/libs/Export2Excel").then((excel) => {
        list.forEach(function(c) {
          if (c.status == "10") {
            c["status"] = "待审批";
          } else if (c.status == "20") {
            c["status"] = "审批完成";
          } else if (c.status == "30") {
            c["status"] = "待拣配";
          } else if (c.status == "40") {
            c["status"] = "拣配中";
          } else if (c.status == "50") {
            c["status"] = "拣配完成";
          } else if (c.status == "60") {
            c["status"] = "出库完成";
          } else if (c.status == "70") {
            c["status"] = "关闭";
          }

          if (c.checkFlag == "10") {
            c["checkFlag"] = "通过";
          } else if (c.checkFlag == "20") {
            c["checkFlag"] = "不通过";
          }

          if (c.directInventory == true) {
            c["directInventory"] = "是";
          } else if (c.directInventory == false) {
            c["directInventory"] = "否";
          }

          if (c.section != undefined && c.deptName != undefined) {
            c["section"] = c.section + "-" + c.deptName;
          }
        });
        const tHeader = [
          "申请单号",
          "物料编号",
          "物料描述",
          "物料类型",
          "需求数量",
          "申请人员",
          "申请部门",
          "状态",
          "申请时间",
          "需求时间",
          "审批部门",
          "申请审批人员",
          "审批状态",
          "不通过原因",
          "审批人员编号",
          "拣货数量",
          "拣货备注",
          "产品型号",
          "工单数量",
          "寿命",
          "工序",
        ];
        const filterVal = [
          "samCode",
          "matCode",
          "matName",
          "mtType",
          "matQuan",
          "person",
          "section",
          "status",
          "createTime",
          "requireDate",
          "examineType",
          "examineWaitPerson",
          "checkFlag",
          "checkMessage",
          "examineEmp",
          "pickQuan",
          "pickRemark",
          "productModel",
          "orderQuantity",
          "life",
          "ddName",
        ];
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "领用申请单",
        });
        this.logContent = "导出";
        this.logRemarks = "stock_auxi_material：导出领用申请记录";
        this.systemLog();
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    /**
     * 操作日志
     */
    systemLog() {
      let objData = {
        logType: "领用申请",
        logContent: this.logRemarks || "",
        //logRemarks: this.logRemarks || "",
        logUser: localStorage.getItem("user") || "",
      };
      this.$http
        .request({
          url: "api/log/insert",
          method: "POST",
          data: objData,
        })
        .then((resp) => {
          this.logContent = "";
          this.logRemarks = "";
          if (resp.status == 100) {
          }
        })
        .catch((error) => {});
    },

    setExamineWait(event) {
      let personList = [];
      this.dictUserList.forEach((item) => {
        if (event.indexOf(item.empNumber) != -1) {
          personList.push(item.userName);
        }
      });
      this.mainObj.examineWaitPerson = personList.join(",");
    },
  },
  activated() {
    this.getDepartmentData();
    /* 获取首页的数据 */
    this.getAuxiMaterialData();
    this.getTypeList();
  },
};
</script>

<style scoped>
.div div {
  width: 170px;
  height: 50px;
  /* border: 1px solid black; */
  margin-left: 10px;
  margin-top: 10px;
  float: left;
  font-weight: 550;
  font-size: 18px;
}

.table table {
  margin-top: 3px;
}

.table table tr td {
  width: 175px;
  height: 50px;
  border: 1px solid black;
  text-align: center;
  font-size: 14px;
  font-weight: 800;
  color: black;
}

.table table tr th {
  width: 175px;
  height: 50px;
  border: 1px solid black;
  font-weight: 800;
  font-size: 18px;
  color: black;
}

.td td {
  font-weight: 800;
  color: black;
}

.color {
  background: rgb(194, 192, 192);
  color: black;
}

.print {
  width: 100%;
  height: 80px;
  /* border: 1px solid red; */
}
</style>
